import { Component, OnInit } from '@angular/core';
import { CommonService } from "../../_services/common.service";

@Component({
  selector: 'app-store-order-list',
  templateUrl: './store-order-list.component.html',
  styleUrls: ['./store-order-list.component.css']
})
export class StoreOrderListComponent implements OnInit {
  tabList: any[];
  public loading = false;
  public storeList: Array<any> = [];
  public Options: any = {};
  public total = 0;
  public pagesToShow = 10;
  public page = 1;
  public limit = 100;
  public search: string = "";
  public sortColumnName = "id";
  public sortDirection = "desc";
  public filterText: string;
  constructor(private CommonService: CommonService) {
    this.tabList = [

      { key: '/stores', val: 'Store', cls: '' },
      { key: '/stores/order', val: 'Order', cls: 'active' },
      { key: '/stores/archive-list', val: 'Archive', cls: '' }

    ]
  }

  ngOnInit() {
    this.getStoreData();
  }

  getStoreData = function () {
    this.loading = true;
    this.Options = {
      shop_id: localStorage.getItem("userID"),
      limit: this.limit,
      page: this.page
    };
    if (this.filterText) {
      this.Options.status = this.filterText;
    }

    this.CommonService.apiService(
      "POST",
      "store/order-list",
      this.Options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.loading = false;
          if (response.data) {
            this.storeList = response.data.records;
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }
  trackByFn(index: any, item: any) {
    return index;
  }
  callAction(value) {
    this.filterText=value;
    this.getStoreData();
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-stores/store-order-list/store-order-list.component.ts